exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.signed-contracts[data-v-a689b5a2] {\n  background: #EDEDED;\n}\n.signed-contracts__table[data-v-a689b5a2] {\n  margin-top: 1.5rem;\n  border-radius: 2px;\n  -webkit-box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);\n          box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.08);\n}\n.counterparty-cell[data-v-a689b5a2] {\n  min-width: 450px;\n}\n.signed-contracts__view-details-btn[data-v-a689b5a2] {\n  float: right;\n}\n.signed-contracts__no-contracts[data-v-a689b5a2] {\n  margin: 1rem auto;\n  text-align: center;\n}\n\n/*\n  .signed-contracts__header { background: $col-content-block; }\n*/\n.signed-contracts__dispute-filter[data-v-a689b5a2] {\n  margin-left: 2.5rem;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a689b5a2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/app/contracts/index/signed/Contracts.SignedList.vue
// module id = ExhY
// module chunks = 1